import { $, $$, alcance, aviso, avisoHtml, cajaRestringida, E_MIS_CAJAS, esc, limpiar, misCajas, noHabilitado, nombreCaja, num, olvidarMisCajas, ordenarPor, pedir, pedirTodo, puede, puedoOperar, repintar, rpc, sb, trabado, trabarSiNoContesto } from './nucleo';
import { MONEDAS, catalogosCobro, frenoMonedas, rotuloMoneda } from './cobros';

// ---------- caja del día ----------
//  La pantalla del punto 8b. Todo lo que decide acá lo decide la base: la
//  pantalla sólo lee las vistas y llama a las ocho RPC de la 0027. Si un
//  botón no aparece es porque falta el permiso, y si aparece y la base
//  igual dice que no, el mensaje que se ve es el de la base.
let CAJAS = [], SESIONES = [], SALDOS_SESION = [], NOMBRE_BOLSIN = 'Bolsín';
//  La habilitación por caja (0031, D48). Si puedo operar cada caja lo contesta
//  `mis_cajas()` (D90; la vista la tapa `caja.ver`, la función es `security
//  definer`); de esta vista sólo sale lo de la CAJA: si está restringida.
let HABIL = [], HABIL_ASIGNADOS = [], HABIL_PERSONAS = [];
//  La tarjeta de abajo tiene SU copia de la misma vista. Ojo: no compartir la
//  variable; una lectura caída de `cargarCaja` pisaría el estado bueno de la otra.
let HABIL_CAJAS = [];
//  Si los dos formularios de plata ya se armaron: engancha el handler una sola
//  vez y pone el destino por omisión.
let BOLSIN_ARMADO = false, GASTO_ARMADO = false, DESTINO_PUESTO = false;
const habilDe = cajaId => HABIL.find(h => h.id === cajaId);

const sesionAbiertaDe = cajaId =>
  SESIONES.find(s => s.caja_id === cajaId && s.estado === 'abierta');

//  Por qué una lista está vacía (regla del 4/9): hay datos, no hay ninguno, no se
//  pudo leer, y una cuarta: el RLS tapa por permiso con lista vacía y `error: null`.
//  Una bandera por consulta, porque cada una cierra una puerta distinta (regla 11).
let SIN_VER = false;
let E_CAJAS = '', E_SESIONES = '', E_ARQUEOS = '', E_SALDOS = '',
    E_BOLSINES = '', E_DESVIOS = '', E_GASTOS = '', E_NOMBRE = '',
    E_HABIL = '', E_COBROS = '', E_H_CAJAS = '', E_H_ASIG = '', E_H_GENTE = '';

//  Tope de la consulta de los cobros sin sesión. Una sola fuente: el cartel "se
//  leyeron los primeros N" tiene que decir el MISMO número que el `.limit()`.
const TOPE_SIN_SESION = 200;

//  El texto de por qué falta algo, en un solo lugar. Devuelve '' si el vacío es
//  legítimo ("todavía no hay ninguna"). El tercer argumento es para lecturas que
//  `caja.ver` NO tapa (`config` la lee cualquier usuario activo).
const motivo = (e: string, que: string, loTapaElPermiso = true) =>
  loTapaElPermiso && SIN_VER
    ? `No tenés permiso para ver ${que}: te falta <b>caja.ver</b>.`
    : e ? `No se pudieron leer ${que} (${esc(e)}).` : '';

export async function cargarCaja(){
  limpiar('#cajaMsg'); limpiar('#cajaOpMsg');
  //  Reintento de esta pantalla: `catalogosCobro()` guarda la promesa y sólo vuelve a
  //  consultar si algo se cayó; esta función corre en cada apertura de la pestaña.
  //  `misCajas()` (D93): a qué caja va cada acto y cuáles puedo operar, mismo camino.
  //  En paralelo: ninguna depende de la otra.
  await Promise.all([catalogosCobro(), misCajas()]);
  //  Cabeceras de las columnas `monto_usd`, en la moneda de catálogo. Se escriben ACÁ,
  //  pegadas al `await` del dato, y no en la función que pinta una tabla: esa no corre
  //  si `v_cobros` se cae.
  $('#thCajaHoy').textContent = 'En ' + rotuloMoneda();
  $('#thCajaSinSesion').textContent = 'En ' + rotuloMoneda();
  const desde = new Date(); desde.setHours(0,0,0,0);

  //  `caja.ver` se pregunta ANTES de consultar (regla 5). Seis de las once lecturas
  //  tienen a `cajas` en un JOIN interno y ese permiso las tapa entera: lista vacía
  //  con `error: null`, indistinguible de "no hay cajas". La combinación existe:
  //  la pestaña la abre `caja.ver` O `caja.operar` (arranque.ts).
  //  Cuáles NO: `v_cobros` y `v_desvios` llegan por LEFT JOIN, sus filas salen igual
  //  (caja en null) y se siguen pidiendo.
  SIN_VER = !puede('caja','ver');
  //  Los desvíos son un permiso aparte y tienen su propia tarjeta.
  const verDesvios = puede('desvio','ver');
  //  Lo que no se consulta contesta sin datos y sin error; ese vacío lo explica `motivo()`.
  const nada = () => Promise.resolve({ data: null, error: null });

  //  LOS SALDOS POR SESIÓN, SÓLO DE LAS SESIONES QUE SE VEN: `v_sesion_saldos` tiene
  //  una fila por sesión y moneda de toda la historia y el servidor corta sin avisar
  //  (D122); si faltan las de la sesión abierta, «Cerrar la caja» quedaría habilitado
  //  (ver `faltan`). Se piden las de las 60 sesiones de la lista, enteras.
  const pSe = SIN_VER ? nada() : pedir(sb.from('v_sesiones_caja').select('*')
      .order('id', { ascending: false }).limit(60));
  const pAr = pSe.then((se: any) => {
    const ids = (se.data || []).map((x: any) => x.id);
    if (SIN_VER || se.error || !ids.length) return { data: se.error ? null : [], error: null };
    return pedirTodo(() => sb.from('v_sesion_saldos').select('*').in('sesion_id', ids)
      .order('sesion_id').order('moneda_id'), { clave: (x: any) => `${x.sesion_id}·${x.moneda_id}` });
  });
  const [ cj, se, ar, sl, bo, dv, ga, cf, hy, ss, hb ] = await Promise.all([
    SIN_VER ? nada() : pedir(sb.from('cajas').select('*').eq('activo', true).order('orden')),
    pSe,
    pAr,
    SIN_VER ? nada() : pedir(sb.from('v_saldo_cajas').select('*')),
    SIN_VER ? nada() : pedir(sb.from('v_bolsines').select('*').eq('estado','en_transito').order('id')),
    !verDesvios ? nada()
      : pedir(sb.from('v_desvios').select('*').in('estado', ['abierto','en_revision']).order('id')),
    //  Los gastos y los cobros de HOY se suman arriba («Entró hoy»): enteros.
    SIN_VER ? nada() : pedirTodo(() => sb.from('v_movimientos_caja').select('*').eq('tipo','gasto')
      .gte('ocurrido_en', desde.toISOString()), { por: 'id', orden: ordenarPor('-ocurrido_en', '-id') }),
    //  `config` la lee cualquier usuario activo: un error es siempre una falla.
    pedir(sb.from('config').select('valor').eq('clave','caja.nombre_transferencia').maybeSingle()),
    //  Las dos de cobros no pasan por `caja.ver` (LEFT JOIN o sin `cajas`): se piden
    //  siempre; sin el permiso sólo se pierde el nombre de la caja (null).
    pedirTodo(() => sb.from('v_cobros').select('*').gte('ocurrido_en', desde.toISOString()),
      { por: 'id', orden: ordenarPor('-ocurrido_en', '-id') }),
    pedir(sb.from('v_cobros_sin_sesion').select('*')
      .order('ocurrido_en', { ascending: false }).limit(TOPE_SIN_SESION)),
    SIN_VER ? nada() : pedir(sb.from('v_cajas_habilitacion').select('*').eq('activo', true).order('orden'))
  ]);

  E_CAJAS    = cj.error?.message || '';
  E_SESIONES = se.error?.message || '';
  E_ARQUEOS  = ar.error?.message || '';
  E_SALDOS   = sl.error?.message || '';
  E_BOLSINES = bo.error?.message || '';
  E_DESVIOS  = dv.error?.message || '';
  E_GASTOS   = ga.error?.message || '';
  E_NOMBRE   = cf.error?.message || '';
  E_COBROS   = hy.error?.message || '';
  E_HABIL    = hb.error?.message || '';

  HABIL = hb.data || [];
  CAJAS = cj.data || []; SESIONES = se.data || []; SALDOS_SESION = ar.data || [];

  NOMBRE_BOLSIN = String(cf.data?.valor ?? 'Bolsín');
  //  D83: un valor de respaldo no habla. Si no se pudo leer cómo lo llama esta
  //  empresa, el título no inventa el nombre.
  $('#tituloBolsines').textContent = E_NOMBRE
    ? 'Envíos entre cajas en tránsito' : NOMBRE_BOLSIN + 'es en tránsito';

  //  El único cartel general, sólo para el permiso: UNA causa que explica seis
  //  tarjetas vacías. Lo que se cae de a una lo dice cada tarjeta. Ojo: dice la
  //  causa y no enumera efectos (una lista se desactualiza y afirma de más; los
  //  cobros del día, por ejemplo, se leen completos igual).
  if (SIN_VER)
    avisoHtml('#cajaMsg','warn','No tenés permiso para ver las cajas ' +
      '(<b>caja.ver</b>). No es que no haya ninguna: es que no se pueden ' +
      'mirar. Cada tarjeta de acá abajo dice si lo que muestra depende de eso.');

  pintarCajas(sl.data || []);
  pintarDesvios(dv.data || [], verDesvios);
  pintarBolsines(bo.data || []);
  pintarGastos(ga.data || []);
  //  Ojo: no cortar acá con un `return` si fallan los cobros: `pintarCobradoHoy` se
  //  desdice sola; si no, quedarían cifras viejas arriba del cartel de error.
  pintarCobradoHoy(hy.data || []);
  pintarSinSesion(ss.data, ss.error);
}

//  Una tarjeta por caja. El arqueo se pide A CIEGAS: hasta que no se cuenta, no se
//  muestra cuánto tendría que haber.
function pintarCajas(saldos){
  const operaP  = puede('caja','operar');
  const arqueaP = puede('caja','arquear');
  //  Los motivos para no saber algo, calculados una vez: son los mismos para todas las cajas.
  const mSaldos   = motivo(E_SALDOS,   'los saldos de las cajas');
  const mSesiones = motivo(E_SESIONES, 'las sesiones de caja');
  const mArqueos  = motivo(E_ARQUEOS,  'los arqueos de la sesión');
  const mHabil    = motivo(E_HABIL,    'las habilitaciones de cada caja');
  //  `mis_cajas()` es `security definer`: `caja.ver` no la tapa, el tercer argumento
  //  va en false. De ella depende el botón, y su silencio hay que decirlo.
  const mMisCajas = motivo(E_MIS_CAJAS, 'las cajas de cada acto de plata', false);
  //  La plata que ya hay (0075, D185): un acto de quien administra, no un dato.
  //  Sin el permiso no se pinta nada.
  const cargaIniP = puede('caja','cargar_inicial');

  $('#cajasLista').innerHTML = CAJAS.map(c => {
    //  Si la caja está restringida y no soy de ella, los botones no van (la base los
    //  rechazaría). Lo contesta `mis_cajas()`, la MISMA fuente que los otros actos de
    //  plata (D93, D90): no volver a `v_cajas_habilitacion`.
    //  Tres respuestas: `null` es NO SE SABE y se ofrece igual; la puerta real es la
    //  base (`exigir_caja`) y esconder todo por una lectura caída es cerrar de más
    //  (regla 11). Se dice abajo.
    const h      = habilDe(c.id);
    const mia    = puedoOperar(c.id) !== false;
    //  `undefined` de las dos = nadie contestó. `mHabil` no alcanza: sin los seis
    //  permisos no hay error de la vista ni fila de `mis_cajas`.
    const restringida = cajaRestringida(c.id) ?? h?.restringida ?? null;
    const opera  = operaP  && mia;
    const arquea = arqueaP && mia;
    const ses  = sesionAbiertaDe(c.id);
    const mias = saldos.filter(s => s.codigo === c.codigo && Number(s.saldo) !== 0);
    //  "vacía" es una afirmación sobre plata: sin lectura no se dice ni "vacía" ni una cifra.
    const plata = mSaldos ? 'no se sabe cuánta plata hay'
      : mias.map(s => `${esc(s.moneda)} ${num(Number(s.saldo))}`).join(' · ') || 'vacía';

    let estado, cuerpo;
    if (ses){
      estado = '<span class="chip c-ok">abierta</span>';
      const filas = SALDOS_SESION.filter(x => x.sesion_id === ses.id);
      const faltan = filas.filter(x => x.contado === null);
      cuerpo = `
        <div class="hint" style="margin:0.353rem 0">Abrió ${esc(ses.abrio || '—')} · ${
          new Date(ses.abierta_en).toLocaleString('es-AR')}</div>
        ${mArqueos ? `<div class="hint"><span class="chip c-bad">${mArqueos}</span>
             Sin eso no se sabe qué monedas hay que contar, así que no se puede
             ni arquear ni cerrar: una lista de cero monedas por contar se ve
             igual que una caja ya contada.</div>` : ''}
        ${filas.map(f => f.contado !== null ? `
          <div class="hint">${esc(f.moneda)}: contaste ${num(Number(f.contado))},
            el sistema decía ${num(Number(f.esperado))}
            ${Number(f.diferencia) === 0
              ? '<span class="chip c-ok">cuadra</span>'
              : `<span class="chip c-bad">${Number(f.diferencia) < 0 ? 'faltan' : 'sobran'} ${
                   num(Math.abs(Number(f.diferencia)))}</span>`}</div>`
          : arquea ? `
          <div style="display:flex;gap:0.353rem;align-items:end;margin:0.235rem 0">
            <label style="flex:1">Contá ${esc(f.moneda)}
              <input type="number" step="0.01" min="0" class="arqInput"
                     data-sesion="${ses.id}" data-moneda="${f.moneda_id}"></label>
            <button class="b b-sec arqBtn" data-sesion="${ses.id}" data-moneda="${f.moneda_id}">Contar</button>
          </div>`
          : `<div class="hint">${esc(f.moneda)}: falta contar</div>`).join('')}
        ${ses.desvios_abiertos > 0
          ? `<div class="hint"><span class="chip c-bad">${ses.desvios_abiertos} ${Number(ses.desvios_abiertos) === 1 ? 'desvío' : 'desvíos'} sin resolver</span>
               No cierra hasta resolverlos.${puede('desvio','ver') ? ''
                 : ' Vos no los podés ver: los mira y los resuelve un administrador.'}</div>` : ''}
        ${arquea ? `<button class="b b-pri cerrarBtn" data-sesion="${ses.id}"
             ${faltan.length || ses.desvios_abiertos || mArqueos ? 'disabled' : ''}
             >Cerrar la caja</button>` : ''}`;
    } else {
      //  "Hoy" lo dice la base, con la zona de la empresa (0028): el
      //  servidor corre en UTC y a la noche ya está en mañana.
      const ultima = SESIONES.find(s => s.caja_id === c.id);
      const hoyYa  = !!(ultima && ultima.es_de_hoy);
      //  Sin las sesiones corre ESTA rama: una caja abierta se ve igual que una que
      //  nunca se abrió. No se afirma el estado ni se ofrece abrir.
      estado = mSesiones ? '<span class="chip c-bad">no se sabe</span>'
             : hoyYa     ? '<span class="chip c-warn">cerrada hoy</span>'
                         : '<span class="chip c-warn">sin abrir</span>';
      cuerpo = mSesiones
        ? `<div class="hint" style="margin:0.353rem 0"><span class="chip c-bad">${mSesiones}</span>
             No se sabe en qué estado quedó, así que no se ofrece abrirla.</div>`
        : `
        ${ultima ? `<div class="hint" style="margin:0.353rem 0">Última: ${esc(ultima.fecha)}, cerró ${
                     esc(ultima.cerro || '—')}</div>` : '<div class="hint" style="margin:0.353rem 0">Nunca se abrió</div>'}
        ${opera && !hoyYa ? `<button class="b b-pri abrirBtn" data-caja="${c.id}">Abrir la caja</button>`
          : hoyYa ? '<div class="hint">Ya se abrió y se cerró hoy.</div>' : ''}`;
    }

    return `<div class="confirmar">
      <b>${esc(c.nombre)}</b> ${estado}
      <div class="hint">${c.cierra_en_cero ? 'Cierra en cero' : 'Acumula'}${
        c.permite_gastos ? ' · paga gastos' : ''}${
        //  Si está restringida lo dice `mis_cajas()` (ya leída para el botón); la vista
        //  queda de respaldo para quien NO mueve plata (D83). Si ninguna contestó no se
        //  calla: la ausencia del renglón se leería como "la opera cualquiera".
        restringida === true  ? ' · sólo la gente asignada'
        : restringida === false ? ''
        : ' · <b>no se sabe si está restringida</b>'}</div>
      <div style="margin:0.353rem 0"><b>${plata}</b></div>
      ${!mia && (operaP || arqueaP)
        ? '<div class="hint"><span class="chip c-warn">no estás asignado a esta caja</span></div>' : ''}
      ${mMisCajas && (operaP || arqueaP)
        ? `<div class="hint"><span class="chip c-warn">${mMisCajas}</span>
             Los botones se ofrecen igual; si esta caja estuviera restringida y
             no fueras de la lista, la base lo va a rechazar.</div>` : ''}
      ${cuerpo}
      ${cargaIniP && mia ? plegableInicial(c, saldos, mSaldos) : ''}
    </div>`;
  }).join('') || `<div class="vacio">${
    motivo(E_CAJAS, 'las cajas') || 'No hay cajas activas'}</div>`;

  $$('#cajasLista .abrirBtn').forEach(b => b.onclick = () => abrirCaja(+b.dataset.caja));
  $$('#cajasLista .cerrarBtn').forEach(b => b.onclick = () => cerrarCaja(+b.dataset.sesion));
  $$('#cajasLista .iniBtn').forEach(b => b.onclick = () =>
    confirmarInicial(b, +b.dataset.caja, +b.dataset.moneda));
  $$('#cajasLista .arqBtn').forEach(b => b.onclick = () => {
    const inp = $(
      `.arqInput[data-sesion="${b.dataset.sesion}"][data-moneda="${b.dataset.moneda}"]`);
    arquear(+b.dataset.sesion, +b.dataset.moneda, inp.value);
  });
}

//  «Cargar la plata que ya hay» (0075, D185): una línea por cada moneda activa
//  que esta caja todavía no movió nunca (sin fila en `v_saldo_cajas`). Sólo con
//  los saldos LEÍDOS: «nunca tuvo movimientos» es una afirmación sobre plata, y
//  sin lectura la tarjeta ya dice «no se sabe cuánta plata hay». Cuando no
//  queda ninguna moneda vacía, el plegable no se pinta.
function plegableInicial(c, saldos, mSaldos){
  if (mSaldos) return '';
  const vacias = MONEDAS.filter(m => !saldos.some(s => s.codigo === c.codigo && s.moneda === m.codigo));
  if (!vacias.length) return '';
  return `<details class="como iniPlegable" data-caja="${c.id}">
      <summary>Cargar la plata que ya hay</summary>
      ${vacias.map(m => `
        <div style="display:flex;gap:0.353rem;align-items:end;margin:0.235rem 0">
          <label style="flex:1">${esc(m.codigo)}
            <input type="number" step="0.01" min="0" class="iniInput"
                   data-caja="${c.id}" data-moneda="${m.id}"></label>
          <button class="b b-sec iniBtn" data-caja="${c.id}" data-moneda="${m.id}">Cargar</button>
        </div>`).join('')}
      <p class="hint">Es para el primer día: se carga una vez por moneda y después
         desaparece. Si te equivocás, se corrige contando la caja.</p>
    </details>`;
}

//  La confirmación va debajo del plegable, con ids propios (la de `cobros.ts`
//  inserta una fila de tabla con ids fijos). Sin `grave`: cargar plata no
//  destruye nada.
let CARGANDO_INI = false;
function confirmarInicial(btn, cajaId, monedaId){
  limpiar('#cajaOpMsg');
  document.getElementById('iniConf')?.remove();
  const inp = $(`.iniInput[data-caja="${cajaId}"][data-moneda="${monedaId}"]`);
  const monto = Number(inp?.value);
  if (!inp || inp.value === '' || !(monto > 0))
    return aviso('#cajaOpMsg','bad','Poné cuánta plata hay.');
  const caja = CAJAS.find(c => c.id === cajaId);
  const mon = MONEDAS.find(m => m.id === monedaId);
  const div = document.createElement('div');
  div.id = 'iniConf';
  div.className = 'confirmar';
  div.innerHTML = `
      <div class="conf-tit">Cargar la plata que ya hay</div>
      <p class="conf-txt">Vas a cargar <b>${esc(mon?.codigo ?? '')} ${num(monto)}</b> en
        <b>${esc(caja?.nombre ?? '')}</b> como la plata que ya había. Se hace una sola vez.</p>
      <div class="grid"><label>Motivo <span class="hint">opcional</span>
        <input id="iniMotivo" autocomplete="off"
               placeholder="Plata que ya había al empezar a usar el sistema"></label></div>
      <div class="fila-acc" style="margin-top:0.706rem">
        <button class="b b-sec" id="iniCancelar" type="button">Cancelar</button>
        <button class="b b-pri" id="iniOk" type="button">Sí, cargar</button>
      </div>`;
  btn.closest('details').after(div);
  $('#iniCancelar').onclick = () => div.remove();
  $('#iniOk').disabled = trabado('#iniOk') || CARGANDO_INI;
  $('#iniOk').onclick = async () => {
    limpiar('#cajaOpMsg');
    const ok = $('#iniOk');
    CARGANDO_INI = true;
    ok.disabled = true;
    const { data, error } = await rpc('cargar_saldo_inicial', {
      p_caja_id: cajaId, p_moneda_id: monedaId, p_monto: monto,
      p_motivo: ($('#iniMotivo').value || '').trim() || null });
    CARGANDO_INI = false;
    //  Una carga que no contestó quizá quedó hecha: el botón no vuelve (D91, D92).
    trabarSiNoContesto('#iniOk', error);
    if (!trabado('#iniOk')) ok.disabled = false;
    if (error) return aviso('#cajaOpMsg','bad', error.message);
    await cargarCaja();
    aviso('#cajaOpMsg','ok', data?.mensaje || 'La plata quedó cargada.');
  };
}

async function abrirCaja(cajaId){
  limpiar('#cajaOpMsg');
  const { data, error } = await rpc('abrir_caja', { p_caja_id: cajaId });
  if (error) return aviso('#cajaOpMsg','bad', error.message);
  await cargarCaja();
  aviso('#cajaOpMsg','ok', data?.mensaje || 'Caja abierta.');
}

async function arquear(sesionId, monedaId, contado){
  limpiar('#cajaOpMsg');
  if (contado === '' || contado === null || isNaN(Number(contado)))
    return aviso('#cajaOpMsg','bad','Escribí cuánto contaste, aunque sea cero.');
  const { data, error } = await rpc('arquear', {
    p_sesion_id: sesionId, p_moneda_id: monedaId, p_contado: Number(contado) });
  if (error) return aviso('#cajaOpMsg','bad', error.message);
  await cargarCaja();
  aviso('#cajaOpMsg', data?.diferencia == 0 ? 'ok' : 'bad', data?.mensaje || 'Contado.');
}

async function cerrarCaja(sesionId){
  limpiar('#cajaOpMsg');
  const { data, error } = await rpc('cerrar_caja', { p_sesion_id: sesionId });
  if (error) return aviso('#cajaOpMsg','bad', error.message);
  await cargarCaja();
  aviso('#cajaOpMsg','ok', data?.mensaje || 'Caja cerrada.');
}

// ---------- quién opera cada caja (0031, D48) ----------
//  Sólo la ve quien tiene `caja.asignar`, que por ahora es un administrador.
//  Las dos reglas del interruptor —no restringir una caja vacía, no sacar al
//  último— están en la base; acá se avisa antes del clic.

export async function cargarHabilitacion(){
  limpiar('#habilMsg');
  //  La abre `caja.asignar`, pero `v_cajas_habilitacion` y `v_caja_usuarios` (JOIN
  //  sin `left` a `cajas`) las tapa `caja.ver`; `usuarios` la lee cualquiera. Se
  //  pregunta antes (regla 5) y se guarda en variables PROPIAS (ver `HABIL_CAJAS`).
  SIN_VER = !puede('caja','ver');
  const nada = () => Promise.resolve({ data: null, error: null });
  const [ ca, as, ge ] = await Promise.all([
    SIN_VER ? nada()
      : pedir(sb.from('v_cajas_habilitacion').select('*').eq('activo', true).order('orden')),
    SIN_VER ? nada() : pedir(sb.from('v_caja_usuarios').select('*').order('usuario')),
    //  La tabla y no v_usuarios (pide gestionar usuarios). Sólo id y nombre: el
    //  email no lo lee la aplicación (0043, D75).
    pedir(sb.from('usuarios').select('id,nombre').eq('activo', true).order('nombre'))
  ]);
  E_H_CAJAS = ca.error?.message || '';
  E_H_ASIG  = as.error?.message || '';
  E_H_GENTE = ge.error?.message || '';
  HABIL_CAJAS = ca.data || [];
  HABIL_ASIGNADOS = as.data || []; HABIL_PERSONAS = ge.data || [];
  pintarHabilitacion();
}

function pintarHabilitacion(){
  //  A `usuarios` no la tapa `caja.ver`: va en false. La de los asignados sí.
  const mAsig  = motivo(E_H_ASIG,  'los asignados a cada caja');
  const mGente = motivo(E_H_GENTE, 'las personas del sistema', false);
  $('#habilitacionLista').innerHTML = HABIL_CAJAS.map(c => {
    const suyos = HABIL_ASIGNADOS.filter(a => a.caja_id === c.id);
    const libres = HABIL_PERSONAS.filter(p => !suyos.some(s => s.usuario_id === p.id));
    return `<div class="confirmar">
      <b>${esc(c.nombre)}</b>
      ${c.restringida
        ? '<span class="chip c-ok">restringida</span>'
        : '<span class="chip c-warn">la opera cualquiera con permiso</span>'}
      <div style="margin:0.471rem 0">
        ${mAsig
          ? `<div class="hint"><span class="chip c-bad">${mAsig}</span></div>`
          : suyos.length
          ? suyos.map(s => `<div style="display:flex;gap:0.353rem;align-items:center;margin:3px 0">
              <span style="flex:1">${esc(s.usuario)}</span>
              <button class="b b-sec quitarBtn" data-caja="${c.id}" data-usuario="${s.usuario_id}"
                      style="padding:0.235rem 0.588rem">Sacar</button></div>`).join('')
          : '<div class="hint">Nadie asignado todavía.</div>'}
      </div>
      <div style="display:flex;gap:0.353rem;align-items:end">
        <label style="flex:1">Sumar a alguien
          <select class="habSel" data-caja="${c.id}" ${mGente || mAsig ? 'disabled' : ''}>
            <option value="">${mGente ? 'no se pudo leer la lista de personas'
              : mAsig ? 'no se sabe quién ya está asignado' : 'Elegí…'}</option>
            ${mGente || mAsig ? '' : libres.map(p =>
              `<option value="${p.id}">${esc(p.nombre)}</option>`).join('')}
          </select></label>
        <button class="b b-sec sumarBtn" data-caja="${c.id}"
                ${mGente || mAsig ? 'disabled' : ''}>Sumar</button>
      </div>
      ${mGente ? `<div class="hint"><span class="chip c-bad">${mGente}</span></div>` : ''}
      ${/*  Restringir sin saber quién queda adentro se traba. DES-restringir no: abre
             la puerta y trabarlo dejaría la caja sin manera de destrabarse.  */''}
      <button class="b ${c.restringida ? 'b-sec' : 'b-pri'} restrBtn" data-caja="${c.id}"
              data-valor="${c.restringida ? 'false' : 'true'}" style="margin-top:0.471rem"
              ${mAsig && !c.restringida
                ? 'disabled title="No se sabe quién opera esta caja"'
                : !c.restringida && suyos.length === 0
                ? 'disabled title="Primero asigná a quién la opera"' : ''}>
        ${c.restringida ? 'Volver a dejarla abierta' : 'Restringirla a esta lista'}</button>
    </div>`;
  }).join('') || `<div class="vacio">${
    motivo(E_H_CAJAS, 'las cajas') || 'No hay cajas activas'}</div>`;

  $$('#habilitacionLista .sumarBtn').forEach(b => b.onclick = () => {
    const sel = $(`.habSel[data-caja="${b.dataset.caja}"]`);
    if (!sel.value) return aviso('#habilMsg','bad','Elegí a quién sumar.');
    habilitarEnCaja(+b.dataset.caja, +sel.value);
  });
  $$('#habilitacionLista .quitarBtn').forEach(b => b.onclick =
    () => quitarDeCaja(+b.dataset.caja, +b.dataset.usuario));
  $$('#habilitacionLista .restrBtn').forEach(b => b.onclick =
    () => restringirCaja(+b.dataset.caja, b.dataset.valor === 'true'));
}

//  Primero se recarga y después se avisa: la recarga limpia el cartel.
async function habilitarEnCaja(cajaId, usuarioId){
  limpiar('#habilMsg');
  const { data, error } = await rpc('habilitar_en_caja',
    { p_caja_id: cajaId, p_usuario_id: usuarioId });
  if (error) return aviso('#habilMsg','bad', error.message);
  olvidarMisCajas();
  await cargarHabilitacion(); await cargarCaja();
  aviso('#habilMsg', data?.restringida ? 'ok' : 'warn', data?.mensaje || 'Habilitado.');
}

async function quitarDeCaja(cajaId, usuarioId){
  limpiar('#habilMsg');
  const { data, error } = await rpc('quitar_de_caja',
    { p_caja_id: cajaId, p_usuario_id: usuarioId });
  if (error) return aviso('#habilMsg','bad', error.message);
  olvidarMisCajas();
  await cargarHabilitacion(); await cargarCaja();
  aviso('#habilMsg','ok', data?.mensaje || 'Listo.');
}

async function restringirCaja(cajaId, valor){
  limpiar('#habilMsg');
  const { data, error } = await rpc('restringir_caja',
    { p_caja_id: cajaId, p_restringida: valor });
  if (error) return aviso('#habilMsg','bad', error.message);
  olvidarMisCajas();
  await cargarHabilitacion(); await cargarCaja();
  aviso('#habilMsg','ok', data?.mensaje || 'Listo.');
}

//  Los desvíos. Causa y resolución son obligatorias en la base; acá el
//  botón sólo se habilita cuando las dos tienen texto, para que el error
//  no llegue después de haber escrito.
//  La casilla de AJUSTAR, lo único de esta tarjeta que mueve plata: `resolver_desvio`
//  exige la habilitación de ESA caja (0045). Dos motivos para no ofrecerla, cada uno
//  con su texto (D87): el desvío NO es de un arqueo (rendición o vuelta: no se
//  ajusta), o es de una caja que no opero.
//  `caja_id` de `v_desvios` sale de la SESIÓN: null para quien no la ve es "no se
//  sabe", no "no te dejan"; ahí se ofrece y contesta la base. El desvío se puede
//  cerrar en los tres casos.
function casillaAjuste(d){
  const esArqueo = d.referencia_tipo === 'sesion_caja';
  const mia = esArqueo ? puedoOperar(d.caja_id) : null;
  //  Los DOS frenos de `resolver_desvio`, en el orden de la base (0045), cada uno con
  //  su motivo (D87).
  if (d.tipo !== 'caja' || !d.moneda || !Number(d.monto))
    return `<div class="hint">Este desvío no se puede ajustar solo: no es de caja,
      o no quedó registrado de qué moneda y por cuánto. Se cierra como resuelto
      o como asumido.</div>`;
  if (!esArqueo)
    return `<div class="hint">Este desvío no se ajusta: la caja ya recibió lo que
      llegó, así que dice lo que hay. Se cierra como resuelto o como asumido.</div>`;
  if (mia === false)
    return `<div class="hint">${noHabilitado(d.caja || nombreCaja(d.caja_id), 'ajustar')}
      Podés cerrarlo igual, sin ajustar.</div>`;
  return `<label><input type="checkbox" class="dvAjusta" data-id="${d.id}">
      Ajustar el saldo: que el sistema pase a decir lo que hay</label>`;
}

function pintarDesvios(desvios, verDesvios){
  const card = $('#cardDesvios');
  //  `desvio.ver` ya se preguntó, y `caja.ver` no tapa esta vista (LEFT JOIN).
  const mDesvios = motivo(E_DESVIOS, 'los desvíos', false);
  //  Se esconde si no hay ninguno, pero NO con la lectura caída: un desvío abierto
  //  traba el cierre de la caja (D37) y hace falta dónde resolverlo.
  if (!verDesvios || (!desvios.length && !mDesvios)){ card.classList.add('oculto'); return; }
  card.classList.remove('oculto');
  const resuelve = puede('desvio','resolver');

  if (mDesvios){
    avisoHtml('#desviosLista','bad', mDesvios + '<br>Si hay alguno abierto, la caja ' +
      'no va a cerrar hasta que se resuelva, y desde acá no se puede ver cuál es.');
    return;
  }

  $('#desviosLista').innerHTML = desvios.map(d => `
    <div class="confirmar grave" style="margin-bottom:0.588rem">
      <b>${esc(d.descripcion)}</b>
      <div class="hint">${esc(d.caja || d.tipo)} · detectó ${esc(d.detecto || '—')} el ${
        new Date(d.detectado_en).toLocaleString('es-AR')}</div>
      ${resuelve ? `
      <div class="grid g2" style="margin-top:0.471rem">
        <label>Por qué pasó<input type="text" class="dvCausa" data-id="${d.id}"></label>
        <label>Qué se hizo<input type="text" class="dvResol" data-id="${d.id}"></label>
        ${casillaAjuste(d)}
        <label>Cómo se cierra
          <select class="dvEstado" data-id="${d.id}">
            <option value="resuelto">Resuelto</option>
            <option value="asumido">Asumido (se da por perdido)</option>
          </select></label>
      </div>
      <button class="b b-pri dvBtn" data-id="${d.id}" style="margin-top:0.471rem">Cerrar el desvío</button>`
      : '<div class="hint">Lo resuelve un administrador.</div>'}
    </div>`).join('');

  $$('#desviosLista .dvBtn').forEach(b => b.onclick = () => resolverDesvio(+b.dataset.id));
}

async function resolverDesvio(id){
  const val = (cls) => $(`.${cls}[data-id="${id}"]`);
  const causa = val('dvCausa').value.trim(), resol = val('dvResol').value.trim();
  if (!causa || !resol)
    return aviso('#cajaOpMsg','bad','Un desvío se cierra con las dos cosas escritas: por qué pasó y qué se hizo.');
  const { data, error } = await rpc('resolver_desvio', {
    p_desvio_id: id, p_causa: causa, p_resolucion: resol,
    //  La casilla puede no estar y `$()` devuelve null: ahí no se ajusta nada.
    p_ajustar: !!val('dvAjusta')?.checked, p_estado: val('dvEstado').value });
  if (error) return aviso('#cajaOpMsg','bad', error.message);
  await cargarCaja();
  aviso('#cajaOpMsg','ok', data?.mensaje || 'Desvío cerrado.');
}

//  Las dos puertas de esta pantalla (bolsín y gasto). Las deciden varias lecturas
//  (monedas de `cobros.ts`, cajas de acá), así que la cuenta vive en una función
//  (regla 13) y mira sólo lo que usa: trabar por medios de pago o moneda de
//  catálogo sería cerrar de más (regla 11).
//  Estados, en orden: no se pudo leer, no se puede ver, y se leyó bien y no alcanza.
//  De qué cajas puedo SACAR plata: `enviar_bolsin` exige `exigir_caja` sobre el
//  ORIGEN, no el destino. Con `mis_cajas` caída la respuesta es null y la caja se
//  ofrece igual: la puerta la tiene la base.
const cajasOrigen = () => CAJAS.filter(c => puedoOperar(c.id) !== false);

function frenoBolsin(){
  const mMonedas = frenoMonedas();
  if (mMonedas) return mMonedas + '<br>Mientras tanto no se puede mandar un ' +
    'bolsín: sin la lista no se sabe en qué moneda va la plata que sale de la caja.';
  const mCajas = motivo(E_CAJAS, 'las cajas');
  if (mCajas) return mCajas + '<br>Mientras tanto no se puede mandar un bolsín: ' +
    'no se sabe de qué caja sale ni a cuál va.';
  if (!MONEDAS.length) return 'No hay ninguna moneda cargada en el sistema, así ' +
    'que no hay en qué expresar el monto del envío.';
  if (CAJAS.length < 2) return CAJAS.length
    ? 'Hay una sola caja activa (<b>' + esc(CAJAS[0].nombre) + '</b>) y un envío ' +
      'necesita dos: una de origen y otra de destino.'
    : 'No hay ninguna caja activa cargada, así que no hay de dónde ni a dónde mandar plata.';
  //  Habilitación por caja (D48, D93): hay cajas, pero ninguna de la que YO pueda sacar plata.
  if (!cajasOrigen().length) return 'No estás habilitado para operar ninguna de ' +
    'las cajas activas, así que no hay de dónde sacar la plata del envío. ' +
    'Un administrador te tiene que asignar a una caja.';
  return '';
}

//  Las cajas que pagan gastos Y que puedo operar: `registrar_gasto` exige la
//  habilitación de la caja elegida.
const cajasGasto = () => CAJAS.filter(c => c.permite_gastos);
const cajasGastoMias = () => cajasGasto().filter(c => puedoOperar(c.id) !== false);

function frenoGasto(pagan){
  const mMonedas = frenoMonedas();
  if (mMonedas) return mMonedas + '<br>Mientras tanto no se puede cargar un ' +
    'gasto: sin la lista no se sabe en qué moneda salió la plata.';
  const mCajas = motivo(E_CAJAS, 'las cajas');
  if (mCajas) return mCajas + '<br>Mientras tanto no se puede cargar un gasto: ' +
    'no se sabe de qué caja sale la plata.';
  if (!MONEDAS.length) return 'No hay ninguna moneda cargada en el sistema, así ' +
    'que no hay en qué expresar el gasto.';
  if (!CAJAS.length) return 'No hay ninguna caja activa cargada, así que no hay ' +
    'de qué caja sacar la plata del gasto.';
  //  No se manda a una pantalla que no existe (regla 16): `permite_gastos` no se
  //  edita desde la aplicación, el cartel dice qué falta y no adónde ir.
  if (!pagan.length) return 'Ninguna de las cajas activas está marcada para pagar ' +
    'gastos (<b>permite_gastos</b>), así que no hay de dónde sacarlos (D38).';
  //  Hay cajas que pagan gastos, pero ninguna es mía (D48, D93).
  if (!cajasGastoMias().length) return 'No estás habilitado para operar ninguna de ' +
    'las cajas que pagan gastos, así que no hay de dónde sacar la plata. ' +
    'Un administrador te tiene que asignar a una de ellas.';
  return '';
}

//  Los dos botones de una fila, cada uno con SU caja: recibir se exige en el DESTINO
//  y anular en el ORIGEN. Un `false` esconde el botón y dice por qué; un null
//  (no se sabe) lo deja y contesta la base.
function botonesBolsin(b){
  const recibo = puedoOperar(b.destino_id), anulo = puedoOperar(b.origen_id);
  const partes: string[] = [];
  if (recibo !== false)
    partes.push(`<button class="b b-pri reciBtn" data-id="${b.id}">Recibir</button>`);
  if (anulo !== false)
    partes.push(`<button class="b b-sec anulBtn" data-id="${b.id}">Anular</button>`);
  const falta: string[] = [];
  if (recibo === false) falta.push('recibirlo en <b>' + esc(b.destino) + '</b>');
  if (anulo  === false) falta.push('anularlo desde <b>' + esc(b.origen) + '</b>');
  return partes.join(' ') + (falta.length
    ? `<div class="hint">No estás habilitado para ${falta.join(' ni ')}.</div>` : '');
}

function pintarBolsines(bols){
  const opera = puede('caja','operar');
  const FRENO = frenoBolsin();
  //  La tabla se desdice sola: "Ninguno en tránsito" es una afirmación sobre plata viajando.
  const mBolsines = motivo(E_BOLSINES, 'los envíos entre cajas');
  $('#tblBolsines').innerHTML = mBolsines
    ? `<tr><td colspan="7" class="vacio">${mBolsines}</td></tr>`
    : bols.map(b => `
    <tr><td class="mono">${esc(b.codigo || ('#' + b.id))}</td>
        <td>${esc(b.origen)}</td><td>${esc(b.destino)}</td>
        <td class="num">${esc(b.moneda)} ${num(Number(b.monto))}</td>
        <td>${esc(b.envio || '—')}</td>
        <td class="hint">${new Date(b.enviada_en).toLocaleString('es-AR')}</td>
        <td>${opera ? botonesBolsin(b) : ''}</td></tr>`)
      .join('') || `<tr><td colspan="7" class="vacio">Ninguno en tránsito</td></tr>`;

  const det = $('#detEnviarBolsin');
  det.classList.toggle('oculto', !opera);
  if (opera){
    //  Los selects de caja también dicen por qué están vacíos (un `<select>` sin
    //  opciones afirma "no hay ninguna caja").
    const mCajas = motivo(E_CAJAS, 'las cajas');
    const ops = mCajas
      ? `<option value="">${mCajas.replace(/<[^>]+>/g, '')}</option>`
      : CAJAS.map(c => `<option value="${c.id}">${esc(c.nombre)}</option>`).join('');
    //  "Desde" lista sólo las que puedo operar; "Hacia", todas: la base
    //  exige la habilitación del ORIGEN y no la del destino.
    const opsOrigen = mCajas
      ? ops
      : cajasOrigen().map(c => `<option value="${c.id}">${esc(c.nombre)}</option>`).join('');
    //  Los selects se repintan SIEMPRE con `repintar()` para no perder lo elegido
    //  (regla 12); llenarlos una sola vez los dejaría vacíos para siempre si la
    //  primera lectura falló (`moneda_id: 0`).
    //  Ojo: `primera` NO se deduce del `innerHTML` del select; un primer pintado
    //  FALLIDO ya lo llena con la `<option>` explicativa y se come la bandera.
    const primera = !BOLSIN_ARMADO;
    BOLSIN_ARMADO = true;
    repintar('#boOrigen', opsOrigen);
    repintar('#boDestino', ops);
    //  Destino por omisión: se pone UNA vez, la primera vez que hay dos cajas de
    //  verdad (no la primera vez que se pinta: con las cajas caídas no gastar la
    //  bandera). Después manda lo que eligió la persona.
    if (!DESTINO_PUESTO && CAJAS.length > 1){
      //  La PRIMERA que no sea la de origen, no el índice 1: "Desde" se recorta a las
      //  cajas que opero y el índice 1 puede caer en el origen.
      const otra = CAJAS.find(c => String(c.id) !== $('#boOrigen').value);
      if (otra){ $('#boDestino').value = String(otra.id); DESTINO_PUESTO = true; }
    }
    repintar('#boMoneda', frenoMonedas()
      ? '<option value="">no se pudieron leer las monedas</option>'
      : MONEDAS.map(m => `<option value="${m.id}">${esc(m.codigo)}</option>`).join(''));
    //  El handler se engancha una sola vez.
    if (primera) $('#btnEnviarBolsin').onclick = enviarBolsin;
    //  La puerta la deciden las monedas Y las cajas.
    $('#btnEnviarBolsin').disabled = !!FRENO || trabado('#btnEnviarBolsin');
    if (FRENO) avisoHtml('#bolsinCatMsg','bad', FRENO);
    else limpiar('#bolsinCatMsg');
  }
  $$('#tblBolsines .reciBtn').forEach(b => b.onclick = () => recibirBolsin(+b.dataset.id));
  $$('#tblBolsines .anulBtn').forEach(b => b.onclick = () => anularBolsin(+b.dataset.id));
}

async function enviarBolsin(){
  limpiar('#bolsinMsg');
  //  Mientras corre la RPC el botón se apaga (dos clics son dos bolsines). Se vuelve
  //  a encender acá abajo y no en el repintado: el camino del error no recarga.
  const btn = $('#btnEnviarBolsin'); btn.disabled = true;
  const { data, error } = await rpc('enviar_bolsin', {
    p_origen_caja_id:  +$('#boOrigen').value,
    p_destino_caja_id: +$('#boDestino').value,
    p_moneda_id:       +$('#boMoneda').value,
    p_monto:  Number($('#boMonto').value),
    p_notas:  $('#boNotas').value.trim() || null });
  //  Se enciende MIRANDO EL FRENO, no a ciegas: mientras viajaba la RPC la pantalla
  //  se pudo recargar sola (Rendiciones llama a `cargarCaja()`) y dejar el freno
  //  puesto; un `disabled = false` seco lo pisaría (`p_caja_id: 0`).
  //  Si la base no contestó, no vuelve: el bolsín quizá salió (D91, D92).
  btn.disabled = !!frenoBolsin();
  trabarSiNoContesto('#btnEnviarBolsin', error);
  if (error) return aviso('#bolsinMsg','bad', error.message);
  $('#boMonto').value = ''; $('#boNotas').value = '';
  aviso('#bolsinMsg','ok', data?.mensaje || 'Enviado.');
  cargarCaja();
}

async function recibirBolsin(id){
  limpiar('#bolsinMsg');
  const { data, error } = await rpc('recibir_bolsin', { p_id: id });
  if (error) return aviso('#bolsinMsg','bad', error.message);
  aviso('#bolsinMsg','ok', data?.mensaje || 'Recibido.');
  cargarCaja();
}

async function anularBolsin(id){
  limpiar('#bolsinMsg');
  //  Ojo: `porQue` y no `motivo`, que sombrearía la función `motivo()` del módulo.
  const porQue = prompt('¿Por qué se anula? Es plata: queda registrado.');
  if (porQue === null) return;
  if (!porQue.trim()) return aviso('#bolsinMsg','bad','Sin motivo no se anula.');
  const { data, error } = await rpc('anular_bolsin', { p_id: id, p_motivo: porQue.trim() });
  if (error) return aviso('#bolsinMsg','bad', error.message);
  aviso('#bolsinMsg','ok', data?.mensaje || 'Anulado.');
  cargarCaja();
}

function pintarGastos(gastos){
  const card = $('#cardGastos');
  if (!puede('gasto','registrar')){ card.classList.add('oculto'); return; }
  card.classList.remove('oculto');

  const pagan = cajasGasto();
  //  Igual que los bolsines: repintar siempre conservando lo elegido (regla 12) y
  //  enganchar el handler una sola vez. La puerta la decide `frenoGasto` (monedas Y
  //  cajas): con `cajas` caída `#gaCaja` queda vacío y saldría `p_caja_id: 0`.
  const FRENO = frenoGasto(pagan);
  const primera = !GASTO_ARMADO;
  GASTO_ARMADO = true;
  const mCajasG = motivo(E_CAJAS, 'las cajas');
  repintar('#gaCaja', mCajasG
    ? `<option value="">${mCajasG.replace(/<[^>]+>/g, '')}</option>`
    : cajasGastoMias().map(c => `<option value="${c.id}">${esc(c.nombre)}</option>`).join(''));
  repintar('#gaMoneda', frenoMonedas()
    ? '<option value="">no se pudieron leer las monedas</option>'
    : MONEDAS.map(m => `<option value="${m.id}">${esc(m.codigo)}</option>`).join(''));
  if (primera) $('#btnGasto').onclick = registrarGasto;
  $('#btnGasto').disabled = !!FRENO || trabado('#btnGasto');
  if (FRENO) avisoHtml('#gastoCatMsg','bad', FRENO);
  else limpiar('#gastoCatMsg');

  const mGastos = motivo(E_GASTOS, 'los gastos de hoy');
  $('#tblGastos').innerHTML = mGastos
    ? `<tr><td colspan="5" class="vacio">${mGastos}</td></tr>`
    : gastos.map(g => `
    <tr><td class="hint">${new Date(g.ocurrido_en).toLocaleTimeString('es-AR',
          {hour:'2-digit',minute:'2-digit'})}</td>
        <td>${esc(g.caja)}</td>
        <td class="num">${esc(g.moneda)} ${num(Math.abs(Number(g.monto)))}</td>
        <td>${esc(g.motivo || '—')}</td>
        <td>${esc(g.usuario || '—')}</td></tr>`).join('')
      || '<tr><td colspan="5" class="vacio">Hoy no salió nada</td></tr>';
}

async function registrarGasto(){
  limpiar('#gastoMsg');
  //  Igual que el bolsín: dos clics son dos gastos.
  const btn = $('#btnGasto'); btn.disabled = true;
  const { data, error } = await rpc('registrar_gasto', {
    p_caja_id:   +$('#gaCaja').value,
    p_moneda_id: +$('#gaMoneda').value,
    p_monto:  Number($('#gaMonto').value),
    p_motivo: $('#gaMotivo').value.trim() });
  //  Con el freno, no a ciegas: ver el comentario de `enviarBolsin`.
  btn.disabled = !!frenoGasto(cajasGasto());
  trabarSiNoContesto('#btnGasto', error);
  if (error) return aviso('#gastoMsg','bad', error.message);
  $('#gaMonto').value = ''; $('#gaMotivo').value = '';
  aviso('#gastoMsg','ok', data?.mensaje || 'Gasto cargado.');
  cargarCaja();
}

function pintarCobradoHoy(hoy){
  //  Con la lectura caída la tabla se desdice, no se muestra un total en cero y no
  //  queda nada viejo arriba del cartel.
  const mCobros = motivo(E_COBROS, 'los cobros de hoy', false);
  if (mCobros){
    avisoHtml('#cajaResumen','bad', mCobros);
    $('#tblCaja').innerHTML = `<tr><td colspan="8" class="vacio">${mCobros}</td></tr>`;
    return;
  }
  //  LA LISTA LA RECORTA `pedido.ver`: `v_cobros` es `pedido_pagos JOIN pedidos` (RLS
  //  «existe el pedido»); con alcance `propio` llegan sólo los cobros de mis pedidos
  //  o de mi vuelta, y sin `pedido.ver` casi ninguno. «Entró hoy» no es el total ni
  //  «Todavía no entró nada» una afirmación válida (D85, D87).
  const veTodos = alcance('pedido','ver') === 'todos';
  const vePedidos = puede('pedido','ver');
  const total = hoy.reduce((a,c) => a + Number(c.monto_usd || 0), 0);
  const porMoneda: Record<string, number> = {};
  hoy.forEach(c => porMoneda[c.moneda] = (porMoneda[c.moneda] || 0) + Number(c.monto || 0));
  //  Sin `pedido.ver` y sin filas, cero no es un dato: es no poder mirar.
  const sinDato = !veTodos && !vePedidos && !hoy.length;
  $('#cajaResumen').innerHTML = `
    <div><div class="hint">Entró hoy (${esc(rotuloMoneda())})${veTodos ? '' : ', de lo que ves'}</div>
         <b style="font-size:1.15rem">${sinDato ? '—' : num(Math.round(total*100)/100)}</b></div>
    <div><div class="hint">Por moneda</div><b>${
      Object.entries(porMoneda).map(([m,v]) => `${esc(m)} ${num(Math.round(v*100)/100)}`).join(' · ') || '—'}</b></div>
    <div><div class="hint">Movimientos</div><b>${sinDato ? '—' : hoy.length}</b></div>${
    veTodos ? '' : `
    <div id="cobradoHoyRecorte" class="hint"><span class="chip c-warn">puede faltar</span> ${vePedidos
      ? 'Sólo se cuentan los cobros de los pedidos que podés ver.'
      : 'Los cobros salen de los pedidos y te falta <b>pedido.ver</b>: de acá no sale casi ninguno.'}</div>`}`;

  $('#tblCaja').innerHTML = hoy.map(c => `
    <tr${c.anulado || c.es_anulacion ? ' style="opacity:.55"' : ''}>
      <td class="hint">${new Date(c.ocurrido_en).toLocaleTimeString('es-AR',{hour:'2-digit',minute:'2-digit'})}</td>
      <td class="mono">${esc(c.pedido || '—')}${
        c.es_anulacion ? ' <span class="chip c-bad">anulación</span>'
        : c.anulado ? ' <span class="chip c-bad">anulado</span>' : ''}</td>
      <td>${esc(c.cliente || '—')}</td>
      <td>${esc(c.medio_pago)}</td>
      <td class="num">${esc(c.moneda)} ${num(Number(c.monto))}</td>
      <td class="num">${num(Number(c.monto_usd ?? 0))}</td>
      <td>${SIN_VER ? '<span class="hint">no la podés ver</span>' : esc(c.caja || '—')}${
        //  Un cobro de la calle no tiene sesión porque no entra a ninguna caja
        //  hasta que se rinde (D182): «sin sesión» es un aviso del mostrador.
        c.sesion_id || c.vuelta_id ? '' : ' <span class="chip c-warn">sin sesión</span>'}</td>
      <td>${esc(c.cobro || '—')}</td>
    </tr>`).join('') || `<tr><td colspan="8" class="vacio">${veTodos
      ? 'Todavía no entró nada hoy'
      : vePedidos
        ? 'Ninguno de los pedidos que podés ver: puede haber cobros de otros.'
        : 'No podés ver ninguno: los cobros salen de los pedidos y te falta <b>pedido.ver</b>.'
    }</td></tr>`;
}


function pintarSinSesion(sin, eS){
  //  `caja.ver` no tapa esta vista (sale de los pagos del pedido): tercer argumento false.
  const m = motivo(eS ? eS.message : '', 'los cobros que quedaron sin sesión', false);
  //  PERO la recorta `pedido.ver`: `v_cobros_sin_sesion` es `pedido_pagos JOIN
  //  pedidos` (JOIN INTERNO), el alcance le saca filas. Con `pedido.ver:propio` sólo
  //  se ven los cobros de SUS pedidos, y esta tarjeta existe para no perder esa plata.
  const veTodos = alcance('pedido','ver') === 'todos';
  const filas = sin || [];
  const tope = filas.length >= TOPE_SIN_SESION;
  $('#tblSinSesion').innerHTML = m
    ? `<tr><td colspan="7" class="vacio">${m}</td></tr>`
    : filas.map(c => `
    <tr><td class="hint">${new Date(c.ocurrido_en).toLocaleString('es-AR')}</td>
        <td class="mono">${esc(c.pedido || '—')}</td>
        <td>${esc(c.cliente || '—')}</td>
        <td>${esc(c.medio_pago)}</td>
        <td class="num">${esc(c.moneda)} ${num(Number(c.monto))}</td>
        <td class="num">${c.monto_usd != null ? num(Number(c.monto_usd)) : '—'}</td>
        <td>${esc(c.cobro || '—')}</td></tr>`).join('')
      //  El vacío no afirma que no quedó ninguno si sólo se sabe de los PROPIOS.
      || `<tr><td colspan="7" class="vacio">${veTodos
          ? 'Ninguno: todo cayó en una sesión de caja'
          //  D87: hay que distinguir falta de permiso de falta de ALCANCE: `alcance()`
          //  devuelve null sin permiso, así que `veTodos` es false en los dos casos.
          : puede('pedido','ver')
            ? 'Ninguno de los que podés ver. Esta lista sale de los pedidos y sólo '
              + 'ves los tuyos: puede haber cobros de otros que quedaron sin sesión.'
            : 'No podés ver ninguno. Esta lista sale de los pedidos y te falta '
              + '<b>pedido.ver</b>: puede haber cobros sin sesión y no lo sabrías.'
        }</td></tr>`;
  //  El aviso del recorte va sólo cuando hay filas: vacía ya lo dice el texto de arriba.
  $('#sinSesionMsg').innerHTML = m || !filas.length ? ''
    : (!veTodos
        ? '<div class="hint"><span class="chip c-warn">puede faltar</span> '
          + (puede('pedido','ver')
              ? 'Sólo se ven los cobros de los pedidos que podés ver: '
              //  «Casi»: sin `pedido.ver` igual salen los cobros de los pedidos de tu
              //  vuelta (tercera rama de `pedidos_ver`).
              : 'Te falta <b>pedido.ver</b>, así que de acá no sale casi ninguno: ')
          + 'puede haber más plata sin sesión de la que figura acá.</div>'
        : '')
      + (tope ? `<div class="hint">Se leyeron los primeros ${num(TOPE_SIN_SESION)}, `
                + `los más nuevos primero. Puede haber más.</div>` : '');
}
